'use strict';

function LandingController($navigation, performanceReviewService, salaryService, $location, $window) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.hasRole = _hasRole;
  vm.isCommonAssessmentOpen = isCommonAssessmentOpen;
  if ($location.path() === '/landing') {
    $window.location.href = '/v2/dashboard';
    return;
  }

  function $onInit() {
    // vm.managerItems = $navigation.routes.filter(_byRole('manager'));
    // vm.adminItems = $navigation.routes.filter(_byRole('admin'));
    // vm.performanceReviewUrl = _getAssessmentTokenUrl(performanceReviewService, vm.me.token.assessment);
    // vm.salaryUrl = _getSalaryTokenUrl(salaryService, vm.me.token.salary);
  }

  function _getAssessmentTokenUrl(service, token) {
    if ((vm.isCommonAssessmentOpen(token.transpire) && token.is_lockable) || token.review) {
      if (token.completed) {
        return service.urls.agreement.questionnaire.base({token: token.token});
      }
      return service.urls.agreement.questionnaire.step({token: token.token, step: 1});
    }
    return service.urls.questionnaire.step({token: token.token, step: 'intro'});
  }

  function _getSalaryTokenUrl(service, token) {
    return service.urls.questionnaire.step({token: token, step: 'intro'});
  }

  function _hasRole(role) {
    return vm.me.groups.map(function (group) {
      return group.name;
    }).some(function (groupName) {
      return groupName === role;
    });
  }

  function _byRole(role) {
    return function (item) {
      return item.role === role;
    };
  }

  function isCommonAssessmentOpen(transpire) {
    return new Date(transpire).getTime() < new Date().getTime();
  }
}

module.exports = LandingController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/landing/landing/landing.controller.js
 ** module id = 191
 ** module chunks = 0
 **/